import script from "./DataItemsList.vue?vue&type=script&setup=true&lang=js"
export * from "./DataItemsList.vue?vue&type=script&setup=true&lang=js"

import "./DataItemsList.vue?vue&type=style&index=0&id=22b5bf84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b5bf84"]])

export default __exports__